import { render, staticRenderFns } from "./AssignError.vue?vue&type=template&id=6d04bf29"
import script from "./AssignError.vue?vue&type=script&lang=js"
export * from "./AssignError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports